import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { RenderedService } from '../../rendered.service';
import { CourseService } from '@scaffold/services/course.service';
import { ItemsService } from '@scaffold/services/items.service';
import { ActivatedRoute } from '@angular/router';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EnvironmentService } from '@services/environment.service';

@Component({
  selector: 'scaffold-connection',
  templateUrl: './connection.component.html',
  styleUrls: ['../../rendered.component.scss', './connection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
/**
 * this component is used to link an item to another item of a different type
 */
export class ConnectionComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy {
  dataItems = [];
  dataItemsOptions = []
  @Input() childview;
  @ViewChild('connectSelect') connectSelect: ElementRef;
  @Output() change = new EventEmitter<any>();
  new: any;
  public destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private courseService: CourseService,
    private itemsService: ItemsService,
    private route: ActivatedRoute,
    private environmentService: EnvironmentService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe((trigger) => {
        this.update();
      });
    if (this.item.list_content) {
      this.dataItems = this.fileterItems(this.item.list_content);
      const initialOptions = this.item.allow_new? [{title:'New',value:'new'}]:[]
      this.dataItemsOptions = [...initialOptions,...this.dataItems.map(item=>({value:this.getDataValue(item),title:this.getTitle(item?.data)}))]
    } else {
      if (this.item.allowed_types && this.item.allowed_types.length > 0) {
        this.getDataItems(this.item.allowed_types[0].name);
      }
    }

    if (this.info.type === 'moduleitems') {
      if (this.item.allow_new) {
        this.item.name = 'reference_id';
        this.item.default = 'new';
        if (!this.info.reference_id) {
          console.log('update to new');
          this.info.reference_id = 'new';
          this.change.emit({ value: 'new' });
        }
      }
    }
    console.log(this.item);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  /**
   * @callback setConnectionData ~ set the connection
   * @param e
   * @param setting
   */

  setConnectionData(e, setting) {
    console.log(e, this.info);
    if (this.info) { this.change.emit({ value: e }); }
  }

  /**
   * @callback getTitle ~ institution title
   * @param data
   * @property {string} title - name
   */

  getTitle(data) {
    let title = data?.title || 'Institution';
    if (this.environmentService.environment.isOPM) {
      title += ' (' + data?.['institution.title'] + ')';
    }
    return title;
  }

  /**
   * @callback getDataValue
   * @param key
   * @property {string} key - the data model key
   */

  getDataValue(key) {
    return key?.data?.[this.item.value_key || 'content_id'];
  }

  /**
   * @callback getDataItems
   * @param type
   */
  getDataItems(type) {
    this.item.child = undefined;
    this.dataItems = [];
    let url;
    if (this.item.global) {
      url = type;
    } else {
      url = 'courses/' + this.courseService.id + '/' + type;
    }
    url +=
      '?output=dataonly&mode=list&key_values=title,title__c,id,content_id,institution.title';
    if (this.item.value_key && this.item.value_key.length > 0) {
      url += ',' + this.item.value_key;
    }
    /**
     * get the list and keep it with the id
     */
    this.courseService.get(url).subscribe((co) => {
      this.dataItems = this.fileterItems(co);
      const initialOptions = this.item.allow_new? [{title:'New',value:'new'}]:[]
      this.dataItemsOptions = [...initialOptions,...this.dataItems.map(item=>({value:this.getDataValue(item),title:this.getTitle(item?.data)}))]
      this.update();
    });
  }

  fileterItems(co) {
    let items;
    if (co) {
      if (co.listItems) {
        items = co.listItems;
      } else {
        items = [co];
      }
      if (this.item.same_insatnce) {
        items = items.filter(
          (i) => i.institution_id === this.info.institution_id
        );
      }
      return items;
    }
    return [];
  }
}
